import React, { ReactNode } from "react";
import { CloseSquareOutlined } from "@ant-design/icons";
import { message } from "antd";
import { uniqueId } from "lodash";
import "antd/dist/reset.css";
import "@ant-design/v5-patch-for-react-19";

export enum NotificationType {
  success = "success",
  error = "error",
  warning = "warning",
  info = "info",
  loading = "loading",
}

export const showMessage = (
  content: ReactNode,
  type: NotificationType,
  key?: string,
  duration?: number
) => {
  const messageKey = key || uniqueId();
  const messageDuration = duration ?? 10;

  const icon = (
    <span
      className="custom-close-icon"
      data-testid={`notif-${messageKey}-close`}
      onClick={() => message.destroy(messageKey)}
      style={{ marginLeft: 8, cursor: "pointer" }}
    >
      <CloseSquareOutlined />
    </span>
  );

  const notificationContent = (
    <div data-testid={`notif-${messageKey}`}>
      {content}
      {icon}
    </div>
  );

  switch (type) {
    case NotificationType.success:
      return message.success({
        content: notificationContent,
        key: messageKey,
        duration: messageDuration,
      });
    case NotificationType.error:
      return message.error({
        content: notificationContent,
        key: messageKey,
        duration: messageDuration,
      });
    case NotificationType.warning:
      return message.warning({
        content: notificationContent,
        key: messageKey,
        duration: messageDuration,
      });
    case NotificationType.info:
      return message.info({
        content: notificationContent,
        key: messageKey,
        duration: messageDuration,
      });
    case NotificationType.loading:
      return message.loading({
        content: notificationContent,
        key: messageKey,
        duration: messageDuration,
      });
  }
};

export const showSuccessPopUp = (
  content: ReactNode,
  key?: string,
  duration?: number
) => showMessage(content, NotificationType.success, key, duration);

export const showErrorPopUp = (
  content: ReactNode,
  key?: string,
  duration?: number
) => showMessage(content, NotificationType.error, key, duration);

export const showWarningPopUp = (
  content: ReactNode,
  key?: string,
  duration?: number
) => showMessage(content, NotificationType.warning, key, duration);

export const showInfoPopUp = (
  content: ReactNode,
  key?: string,
  duration?: number
) => showMessage(content, NotificationType.info, key, duration);

export const showLoadingPopUp = (
  content: ReactNode,
  key?: string,
  duration?: number
) => showMessage(content, NotificationType.loading, key, duration);
